/**************************************************************************************************/
/** @internal Type @name TextValidAlignTypes                                                     **/
/**************************************************************************************************/
type TextValidAlignTypes = 'left' | 'center' | 'right' | 'top' | 'bottom'

/**************************************************************************************************/
/** @internal Class @name ElementPDF                                                             **/
/**************************************************************************************************/
class ElementPDF
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private align: TextValidAlignTypes = 'left'
	private gap = 0
	private offset: number

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(offset: number)
	{
		this.offset = offset
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public getAlign() : TextValidAlignTypes
	{
		return this.align
	}

	public getGap() : number
	{
		return this.gap
	}

	public getOffset() : number
	{
		return this.offset
	}

	public setAlign(a: TextValidAlignTypes) : this
	{
		this.align = a
		return this
	}

	public setGap(n: number) : this
	{
		this.gap = n
		return this
	}
}

/**************************************************************************************************/
/** @export Class @name ImagePDF                                                                 **/
/**************************************************************************************************/
export class ImagePDF extends ElementPDF
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private w: number
	private h: number
	private src: string

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(offset: number, w: number, h: number, src: string)
	{
		super(offset)
		this.w = w
		this.h = h
		this.src = src
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public getHeight() : number
	{
		return this.h
	}

	public getSource() : string
	{
		return this.src
	}

	public getWidth() : number
	{
		return this.w
	}
}

/**************************************************************************************************/
/** @export Class @name TextPDF                                                                  **/
/**************************************************************************************************/
export class TextPDF extends ElementPDF
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private color: string
	private fontName = 'OpenSans-Normal'
	private fontStyle = 'normal'
	private fontSize: number
	private text: string

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(text: string, offset = 0, fontSize = 0, color = 'black')
	{
		super(offset)
		this.color = color
		this.fontSize = fontSize
		this.text = text
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public getColor() : string
	{
		return this.color
	}

	public getFont() : { font: string, style: string }
	{
		return { font: this.fontName, style: this.fontStyle }
	}

	public getFontSize() : number
	{
		return this.fontSize
	}

	public getText() : string
	{
		return this.text
	}

	public setFont(fontName: string, style?: string) : this
	{
		this.fontName = fontName
		if (style) this.setStyle(style)
		return this
	}

	public setStyle(fontStyle: string) : this
	{
		this.fontStyle = fontStyle
		return this
	}
}